import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Group() {
    const {
        group, setGroup,
        listGroups
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Grupos da Ocorrência:
            </Typography>

            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setGroup(e.target.value)}
                    value={group}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {listGroups.map((res, idx) => (
                        <MenuItem value={res.nameSecretary} key={idx}>
                            {res.nameSecretary}
                        </MenuItem>)
                    )}
                </Select>
            </FormControl>
        </>
    );
}